/**
 * @deprecated Don't use this function unless you really intend to emit logging in the product.
 */
export function productLog(...messages: unknown[]): void {
  console.log(...messages);
}
